import { OrangeButtonWithIcon, RouteButton } from "@/components/Buttons";
import { CiEdit } from "react-icons/ci";
import { SubmittalProps } from "@/interfaces/submittal_types";
import { useNavigate } from "react-router-dom";
import { deleteSubmittal, markSubmittalAsCompleted } from "@/api/submittal";
import { FaCheck, FaRegEnvelopeOpen } from "react-icons/fa";
import { AiOutlineDelete } from "react-icons/ai";

export function EditSubmittalButton({submittal_id}: {submittal_id: string}) {
    return (
        <RouteButton route={`/submittals/update_submittal/${submittal_id}`} text="Edit" icon={<CiEdit />} />
    )
}

export function HandleClose({data}: {data: SubmittalProps}) {
    const navigate = useNavigate()

    const handleClose = async () => {
        if (confirm("Are you sure you want to close this submittal?")) {
            if (data.submittal_id) {
                const response = await markSubmittalAsCompleted(data.submittal_id)
                if (response.operation === "COMPLETED") {
                    alert("Submittal closed successfully")
                    navigate("/submittals")
                } else {
                    alert("Error closing submittal: " + response)
                }
            } else {
                alert("Submittal ID is not defined")
            }
        }
    }

    return (
        <OrangeButtonWithIcon onClick={handleClose} icon={<FaCheck />}>Close</OrangeButtonWithIcon>
    )
}

export function HandleDelete({data}: {data: SubmittalProps}) {
    const navigate = useNavigate()

    const handleDelete = async () => {
        if (confirm("Are you sure you want to delete this submittal?")) {
            if (data.submittal_id) {
                const response = await deleteSubmittal(data.submittal_id)
                if (response.operation === "COMPLETED") {
                    alert("Submittal deleted successfully")
                    navigate("/submittals")
                } else {
                    alert("Error deleting submittal: " + response)
                }
            } else {
                alert("Submittal ID is not defined")
            }
        }
    }

    return (
        <OrangeButtonWithIcon onClick={handleDelete} icon={<AiOutlineDelete />}>Delete</OrangeButtonWithIcon>
    )
}

export function HandleEmail({data}: {data: SubmittalProps}) {
    const handleEmailClick = () => {
        const recipient = data.assigned_to_obj?.email
        const ccRecipient = data.assigned_by_obj?.email
        const subject = `Regarding Submittal for Project ${data.project_name ?? 'N/A'}`
        const body = `Hello ${data.assigned_to ?? ''},\n\nPlease see the details for Submittal ${data.sub_number ?? 'N/A'}:\n\nDescription:\n${data.sub_description}\n\nThank you,\n${data.assigned_by ?? ''}`

        if (!recipient) {
            alert("Cannot send email: Assigned person's email is missing.")
            return
        }

        let mailtoUrl = `mailto:${recipient}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`

        if (ccRecipient) {
            mailtoUrl += `&cc=${encodeURIComponent(ccRecipient)}`
        }
        
        window.location.href = mailtoUrl
    }

    return (
        <OrangeButtonWithIcon onClick={handleEmailClick} icon={<FaRegEnvelopeOpen />}>Email Assigned User</OrangeButtonWithIcon>
    )
}